import { useState } from "react";
import { Plus } from "lucide-react";
import { useDispatch } from "react-redux";

import { Input } from "../../../Components/StakingRisk/ui/input";
import { Button } from "../../../Components/StakingRisk/ui/button";
import { AddCustomParameterThunk } from "../../../Store/Thunks/StakingRiskThunk";

export default function AdditionalParameter({ id }) {
  const [newParameter, setNewParameter] = useState("");
  const [isAdding, setIsAdding] = useState(false);

  const dispatch = useDispatch();
  const handleAddParameter = () => {

    if (!newParameter.trim()) return;   
     
    dispatch(AddCustomParameterThunk({ "name": newParameter.trim(),
    "stakingRiskClassificationId": id}))
    setNewParameter("");
    setIsAdding(false);

  };

  return (
    <div className="mt-4">
      {isAdding ? (
        <div className="flex gap-2">
          <Input
            placeholder="Parameter name"
            value={newParameter}
            onChange={(e) => setNewParameter(e.target.value)}
            autoFocus
            onKeyDown={(e) => {
              if (e.key === "Enter") handleAddParameter();
              if (e.key === "Escape") setIsAdding(false);
            }}
          />
          <Button 
            onClick={handleAddParameter}
            className="whitespace-nowrap bg-blue-600 hover:bg-blue-700 text-white"
          >
            Add
          </Button>
          <Button 
            variant="outline"
            onClick={() => setIsAdding(false)}
          >
            Cancel
          </Button>
        </div>
      ) : (
        <Button
          variant="outline"
          className="flex items-center gap-2"
          onClick={() => setIsAdding(true)}
        >
          <Plus className="h-4 w-4" />
          Add Parameter
        </Button>
      )}
    </div>
  );
}